import { client } from './apiClient';

const SESSION_KEY = 'token';

interface SessionData {
  api_token: string;
}

export class BaseService {
  headers: Record<string, string> = {};
  url_prefix: string;

  constructor(url_prefix: string = '') {
    this.url_prefix = url_prefix;
    this.getHeaders();
  }

  async get<T = any>(url: string, queryParams?: Record<string, any>): Promise<T> {
    return client.get(this.getUrl(url) + this.mapQueryParams(queryParams), {
      headers: this.headers
    });
  }

  async post<T = any>(url: string, body?: any, queryParams: Record<string, any> | null = null): Promise<T> {
    return await client.post(
      this.getUrl(url) + this.mapQueryParams(queryParams),
      body,
      {
        method: 'POST',
        headers: this.headers
      }
    );
  }

  async put<T = any>(url: string, body?: any, queryParams: Record<string, any> | null = null): Promise<T> {
    return client.put(
      this.getUrl(url) + this.mapQueryParams(queryParams),
      body,
      {
        method: 'PUT',
        headers: this.headers
      }
    );
  }

  async remove<T = any>(url: string, queryParams: Record<string, any> | null = null): Promise<T> {
    return client.delete(this.getUrl(url) + this.mapQueryParams(queryParams), {
      method: 'DELETE',
      headers: this.headers
    });
  }

  async newPost(url: string, body?: any, queryParams: Record<string, any> | null = null): Promise<void> {
    await client.post(
      this.getUrl(url) + this.mapQueryParams(queryParams),
      body,
      {
        method: 'POST',
        headers: this.headers
      }
    ).catch(error => {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        throw error;
      }
    });
  }

  getUrl(url: string): string {
    return this.url_prefix + url;
  }

  getHeaders(): void {
    this.headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    };
    if (this.checkSession()) {
      let apiToken = this.getSession()!.api_token;
      this.headers = {
        ...this.headers,
        Authorization: `Bearer ${apiToken}`
      };
    }
  }

  getSession(): SessionData | null {
    let session = localStorage.getItem(SESSION_KEY);
    if (session) {
      return JSON.parse(session);
    }
    return null;
  }

  checkSession(): boolean {
    return localStorage.getItem(SESSION_KEY) !== null;
  }

  mapQueryParams(queryParams?: Record<string, any> | null): string {
    return queryParams
      ? `?${Object.keys(queryParams)
          // .map(key => `${key}=${queryParams[key]}`)
          .map(key => {
            let value = queryParams[key];
            if (Array.isArray(value)) {
              value = value.join(`&${key}=`);
            }
            return `${key}=${value}`;
          })
          .join('&')}`
      : '';
  }
}
